module.exports = __webpack_public_path__ + "static/bl-01-7e8d9a5ddf9c6c633792c9cbb1f2d7b7.svg";